import React, { useEffect, useState, useRef } from "react";
import { Col, Form, Input,  Modal, Row,  Spin, Typography, Flex, Space, Button } from "antd";
import { nameFieldValidator } from "../helper.js";
import { renderInfoTip } from "../../us_privacy_regulation/helper.js";
import { downloadLegalDocument } from "../../../../api/preferences.js";
import TextEditor from "./TextEditor.jsx";
import { text } from "d3";

const EditDocumentModalEditor = (props) => {
  const [form] = Form.useForm();
  const getWrappedHtmlRef = useRef(null);

  useEffect(() => {
    if(props.documentToEdit) {
      const { documentName,  versionName, webPageLink } = props.documentToEdit;
      
      downloadLegalDocument(props.documentToEdit._id, 'editor').then((res) => { 
        form.setFieldsValue({
          documentName,
          versionName,
          webPageLink,
          textEditor: res,
        });
      })
    }
  }, [props.documentToEdit])


  const onFinish = (arg, publish) => {
    const content = getWrappedHtmlRef.current?.();
    const document = {
      documentName: arg.documentName,
      versionName: arg.versionName,
      webPageLink: arg.webPageLink,
      content,
    }

    props.handleSaveDocument(document, props.documentToEdit.isLatest, publish)
  }

  const onFinishFailed = (arg) => {
    //todo
  }
  
  return (
    <Modal
      className="legal-doc-edit-modal"
      title="Text Editor"
      onOk={form.submit}
      onCancel={props.onCancel}
      okText="Save"
      width={1366}
      open={props.open}
      destroyOnClose={false}
      confirmLoading={props.loading}
      footer={
        props.documentToEdit.status === 'LIVE'
          ? null
          : (
            <Flex justify="flex-end" align="center">
              <Space>
                { props.documentToEdit.status !== 'LIVE' &&
                  <Button
                    onClick={() => {
                      form.validateFields().then((values) => onFinish(values, false));
                    }}
                  >
                    Save as Draft
                  </Button>
                }
                <Button
                  type="primary"
                  loading={props.loading}
                  onClick={() => {
                    form.validateFields().then((values) => onFinish(values, true));
                  }}
                >
                  Publish
                </Button>
              </Space>
            </Flex>
            )
      }
    >
      <Spin spinning={props.loading}>
      <Form
        form={form}
        name="ldms"
        layout="vertical"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        requiredMark={"optional"}
      >
        <Row gutter={[20, 16]}>
          <Col span={props.documentToEdit.isLatest ? 12 : 24}>
            <Form.Item
              label={<>Document name {renderInfoTip("The name of the new document category you're creating.")}</>}
              name={"documentName"}
              rules={[
                {
                  required: true,
                  message: "Please enter Document Name"
                },
                {
                  validator:(_,value) =>  nameFieldValidator(value, props.documentNames, "Document name")
                }
              ]}
              hidden={!props.documentToEdit.isLatest}
            >
              <Input disabled={props.documentToEdit.status === 'LIVE'} maxLength={255} showCount={true} />
            </Form.Item>
            {props.documentToEdit.isLatest ? null : (
              <Typography.Text>Document Name <Typography.Text strong>: {props.documentToEdit.documentName}</Typography.Text></Typography.Text>
            )}
          </Col>
          <Col span={8}>
            <Form.Item
              label={<>Version name{renderInfoTip("Defaults to the file name but can be edited. Helps track document versions.")}</>}
              name={"versionName"}
              rules={[
                {
                  required: true,
                  message: "Please enter Version Name"
                },
                {
                  validator:(_,value) =>  nameFieldValidator(value, props.docTypeGroup?.documents?.map((doc) => doc.versionName)?.filter((verName) => verName !== props.documentToEdit?.versionName), "Version name")
                }
              ]}
            >
              <Input disabled={props.documentToEdit.status === 'LIVE'} maxLength={255} showCount={true}/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item 
              label={<>Webpage Link{renderInfoTip(" The link to the document that users will see.")}</>}
              required={false}
              name={"webPageLink"}
              rules={[
                {
                  type: "url"
                }
              ]}
            >
              <Input disabled={props.documentToEdit.status === 'LIVE'} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Text Editor"
              name="textEditor"
              rules={[
                {
                  required: true,
                  message: "Please enter text",
                },
              ]}
            >
              <TextEditor
                value={form.getFieldValue("textEditor")}
                onChange={(val) => {
                  form.setFieldsValue({ textEditor: val });
                }}
                disabled={props.documentToEdit.status === 'LIVE' ? true : false}
                sites={props.sites}
                getWrappedHtmlRef={getWrappedHtmlRef}
                features={props.features}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      </Spin>
    </Modal>
  );
}

export default EditDocumentModalEditor;